import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [submenuPosition, setSubmenuPosition] = useState(0);
  const menuRefs = useRef({});
  const navigate = useNavigate();
  const hideTimeoutRef = useRef(null);

  const menuItems = [
    {
      id: 'sales-operations',
      title: 'Sales & Operations',
      icon: '📊',
      submenu: [
        { title: 'Overall S&OP Process', path: '/overall-sop' },
        { title: 'Global Forecasting', path: '/global-forecasting' },
        { title: 'Product Forecasting', path: '/forecasting' },
        { title: 'Production Schedule', path: '/production-schedule' },
        { title: 'Production Planning', path: '/production-planning' },
        { title: 'Component Planning', path: '/component-planning' },
        { title: 'Component Ordering', path: '/component-ordering' }
      ]
    },
    {
      id: 'configuration',
      title: 'Configuration',
      icon: '⚙️',
      submenu: [
        { title: 'BOM and Components', path: '/bom-components' },
        { title: 'Component Costs', path: '/component-costs' },
        { title: 'S&OP Parameters', path: '/sop-parameters' },
        { title: 'SKU List', path: '/sku-list' },
        { title: 'Sundeep Invoice Mapping', path: '/sundeep-invoice-mapping' },
        { title: 'Manage API Connections', path: '/manage-api-connections' }
      ]
    },
    {
      id: 'data-utilities',
      title: 'Data Utilities',
      icon: '🔧',
      submenu: [
        { title: 'Amazon Sales Data', path: '/amazon-sales-data' },
        { title: 'Amazon Payment Data', path: '/new-amazon-payment-data' },
        { title: 'Amazon Inventory Data', path: '/amazon-inventory-data' },
        { title: 'Shopify Sales Data', path: '/shopify-sales-data' },
        { title: 'Trade Sales Management', path: '/trade-sales-management' },
        { title: 'QBO History', path: '/qbo-history' },
        { title: 'Austin Inventory', path: '/austin-inventory' },
        { title: 'Sundeep Component Inventory', path: '/component-inventory' }
      ]
    },
    {
      id: 'accounting-automation',
      title: 'Accounting Automation',
      icon: '💰',
      submenu: [
        { title: 'Sundeep Invoice Process', path: '/invoice-processing' },
        { title: 'Monthly JE - Finished Goods Creation', path: '/journal-entries' },
        { title: 'Monthly JE - Finished Goods Depletion', path: '/journal-entries-depletion' },
        { title: 'Post Amazon Payments', path: '/post-amazon-payments' },
        { title: 'Audit FG Inventory', path: '/audit-fg-inventory' },
        { title: 'Audit Component Inventory', path: '/audit-component-inventory' }
      ]
    },
    {
      id: 'financial-planning',
      title: 'Financial Planning',
      icon: '📈',
      submenu: [
        { title: 'Product Profit Analysis', path: '/profit-analysis' },
        { title: 'P&L and Cash Forecasting', path: '/cash-forecasting' }
      ]
    },
    {
      id: 'reporting',
      title: 'Reporting',
      icon: '📋',
      submenu: [
        { title: 'Amazon Sales', path: '/amazon-sales' },
        { title: 'Shopify Sales Report', path: '/shopify-sales-report' }
      ]
    }
  ];

  const handleMouseEnter = (menuId) => {
    // Clear any existing timeout
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
    
    setActiveMenu(menuId);
    
    // Calculate the position of the menu item
    if (menuRefs.current[menuId]) {
      const rect = menuRefs.current[menuId].getBoundingClientRect();
      setSubmenuPosition(rect.top);
    }
  };

  const handleMouseLeave = () => {
    // Add a small delay before hiding the submenu
    hideTimeoutRef.current = setTimeout(() => {
      setActiveMenu(null);
    }, 150); // 150ms delay
  };

  const handleSubmenuMouseEnter = () => {
    // Clear the hide timeout when hovering over submenu
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
  };

  const handleSubmenuMouseLeave = () => {
    // Add delay when leaving submenu
    hideTimeoutRef.current = setTimeout(() => {
      setActiveMenu(null);
    }, 150);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img 
          src="/Logo.svg" 
          className="sidebar-logo" 
          alt="Ingreendients Logo" 
        />
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className="menu-item"
            ref={(el) => (menuRefs.current[item.id] = el)}
            onMouseEnter={() => handleMouseEnter(item.id)}
            onMouseLeave={handleMouseLeave}
          >
            <div className="menu-item-content">
              <span className="menu-icon">{item.icon}</span>
              <span className="menu-title">{item.title}</span>
              <span className="menu-arrow">▶</span>
            </div>
          </div>
        ))}
      </nav>
      
      {/* Render submenu outside the sidebar */}
      {activeMenu && (
        <div 
          className="submenu"
          style={{ top: `${submenuPosition}px` }}
          onMouseEnter={handleSubmenuMouseEnter}
          onMouseLeave={handleSubmenuMouseLeave}
        >
          {menuItems.find(item => item.id === activeMenu)?.submenu.map((subItem, index) => (
            <a
              key={index}
              href={subItem.path}
              className="submenu-item"
              onClick={(e) => {
                e.preventDefault();
                navigate(subItem.path);
                setActiveMenu(null);
                if (hideTimeoutRef.current) {
                  clearTimeout(hideTimeoutRef.current);
                  hideTimeoutRef.current = null;
                }
              }}
            >
              {subItem.title}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default Sidebar; 